import type { IceCream } from "../schema/IceCream.js";
import type { Locale } from "../schema/Locale.js";

export function getIceCreamName(
	{ flavour1, flavour2 }: Pick<IceCream, "flavour1" | "flavour2">,
	locale: Locale,
): string {
	if (flavour1[locale] === flavour2[locale]) {
		return flavour1[locale];
	}
	return `${flavour1[locale]} & ${flavour2[locale]}`;
}
